import React, { useEffect, useState } from "react";
import styles from "./style.module.scss";

import Header from "./Children/Header/Header";
import MainTabs from "./Children/MainTabs/MainTabs";
import SubTabs from "./Children/SubTabs/SubTabs";

const PageHeader = ({
	header,
	pageTitle,
	navigationData,
	onTabClick,
	activeMainTab,
	showMainTabs = false,
	hideShadow = false,
	showSubTabs = false,
	onSubTabChange,
	showSearch = false,
	searchValue,
	onSearchChange,
	onSearch,
	searchPlaceholder,
	showDateRange = false,
	dateRangeValue,
	onDateRangeChange,
	disabledDate,
	dateFormat,
	granularity,
	showGranularity = true,
	onGranularityChange,
	granularityDisabled = false,
	showAction = false,
	onAction,
	actionLabel,
	actionIcon,
	showDownload = false,
	onDownload,
	downloadLoading = false,
	downloadLabel,
	downloadIcon,
	downloadIconOnly = false,
	searchSuffix,
	headerExtra,
	searchDisabled = false,
}) => {
	const [activeSubTab, setActiveSubTab] = useState("");
	const currentMainTab = navigationData && navigationData.length > 0 && navigationData.find((tab) => tab.id === activeMainTab);

	const handleSubTabChange = (id) => {
		setActiveSubTab(id);
		if (onSubTabChange) onSubTabChange(id);
	};

	useEffect(() => {
		if (
			currentMainTab &&
			currentMainTab.subTabs &&
			currentMainTab.subTabs.length > 0
		) {
			const firstId = currentMainTab.subTabs[0].id;
			setActiveSubTab(firstId);
			if (onSubTabChange) onSubTabChange(firstId);
		} else {
			setActiveSubTab("");
		}
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [activeMainTab]);

	return (
		<div className={styles.wrapper}>
			<nav className={`${styles.nav}${!showMainTabs && !hideShadow ? ` ${styles.navShadow}` : ""}`}>
				<Header
					header={header}
					pageTitle={pageTitle}
					showSearch={showSearch}
					searchValue={searchValue}
					onSearchChange={onSearchChange}
					onSearch={onSearch}
					searchPlaceholder={searchPlaceholder}
					showDateRange={showDateRange}
					dateRangeValue={dateRangeValue}
					onDateRangeChange={onDateRangeChange}
					disabledDate={disabledDate}
					dateFormat={dateFormat}
					granularity={granularity}
					showGranularity={showGranularity}
					onGranularityChange={onGranularityChange}
					granularityDisabled={granularityDisabled}
					showAction={showAction}
					onAction={onAction}
					actionLabel={actionLabel}
					actionIcon={actionIcon}
					showDownload={showDownload}
					onDownload={onDownload}
					downloadLoading={downloadLoading}
					downloadLabel={downloadLabel}
					downloadIcon={downloadIcon}
					downloadIconOnly={downloadIconOnly}
					searchSuffix={searchSuffix}
					headerExtra={headerExtra}
					searchDisabled={searchDisabled}
				/>

				{showMainTabs ? (
					<MainTabs
						navigationData={navigationData}
						activeMainTab={activeMainTab}
						onTabClick={onTabClick}
					/>
				) : null}

				{showSubTabs ? (
					<SubTabs
						currentMainTab={currentMainTab}
						activeSubTab={activeSubTab}
						setActiveSubTab={handleSubTabChange}
					/>
				) : null}
			</nav>
		</div>
	);
};

export default PageHeader;
